import { Card, Box, CardBody } from '@chakra-ui/react';
import { NestedHome, NestedUser } from '@habity/types';
import { HomeImageCard } from './ImageCard';
import { HomeCardData } from './components/HomeCardData';
import { getHomePath } from '@habity/services';
import { useUser } from '~/hooks/useUser';
import { isAddedToWishlist } from '@habity/services';
import { ListSkeleton } from '~/components/homes/list/components/ListSkeleton';

type MapCardProps = {
  isLoading: true;
  home: NestedHome | undefined;
  user?: NestedUser;
} | {
  isLoading: false;
  home: NestedHome;
  user?: NestedUser;
};

export const MapCard = ({
  home,
  isLoading,
  user: propUser,
}: MapCardProps) => {
  // Use the user from context if not provided as a prop
  const { user: contextUser } = useUser();
  const user = propUser || (contextUser || undefined);

  if (isLoading) {
    return (
      <ListSkeleton
        position="absolute"
        top="4"
        left="4"
        isLoaded={false}
        w="300px"
        h="520px"
        startColor="whiteAlpha.600"
        endColor="whiteAlpha.800"
      />
    );
  }

  // Check if the home is in the user's wishlist
  const addedToWishlist = user
    ? isAddedToWishlist(user, home.id)
    : false;

  return (
    <Card
      maxW="md"
      w="300px"
      overflow="hidden"
      m={{ mobile: '0', desktop: '4' }}
      borderRadius="4px"
      className="group"
    >
      <Box
        position="relative"
        overflow="hidden"
      >
        <HomeImageCard
          home={home}
          isLoading={isLoading}
          user={user}
          href={getHomePath(home)}
          imageVariant="list"
          onClick={() => null}
          imageProps={{ w: '100%' }}
          borderTopRadius='0'
          borderBottomRadius='0'
          boxProps={{ maxW: '400px' }}
          pagination={{
            type: 'bullets',
          }}
          maxSlides={3}
          aspectRatio={1 / 1.2}
          allowActions={true}
          addedToWishlist={addedToWishlist}
        />
      </Box>
      <CardBody px="3" py="2">
        <HomeCardData
          home={home}
          isLoading={isLoading}
          href={getHomePath(home)}
          variant="compact"
        />
      </CardBody>
    </Card>
  );
};
